/** Shared cap on lowered simulation work, including nodes and edges. */
export const MAX_LOWERED_GRAPH_ITEMS = 200_000;
